import apiClient, { buildQueryParams } from '../utils/apiClient';
import { handleError } from '../utils/errorHandler';
import { API_ENDPOINTS } from '../constants/apiEndpoints.constants';

const rejectionReasonService = {
  getAll: async (params = {}) => {
    try {
      const {
        page = 1,
        limit = 50,
        search = '',
        status = '',
        sortBy = 'createdAt',
        sortOrder = 'desc',
      } = params;

      const queryParams = buildQueryParams({
        page,
        limit,
        search,
        status,
        sortBy,
        sortOrder,
      });

      return await apiClient.get(`${API_ENDPOINTS.REJECTION_REASONS.LIST}?${queryParams}`);
    } catch (error) {
      throw new Error(handleError(error, 'rejectionReasonService.getAll'));
    }
  },

  getById: async (id) => {
    try {
      return await apiClient.get(API_ENDPOINTS.REJECTION_REASONS.GET_BY_ID(id));
    } catch (error) {
      throw new Error(handleError(error, 'rejectionReasonService.getById'));
    }
  },

  create: async (data) => {
    try {
      return await apiClient.post(API_ENDPOINTS.REJECTION_REASONS.CREATE, data);
    } catch (error) {
      throw new Error(handleError(error, 'rejectionReasonService.create'));
    }
  },

  update: async (id, data) => {
    try {
      return await apiClient.put(API_ENDPOINTS.REJECTION_REASONS.UPDATE(id), data);
    } catch (error) {
      throw new Error(handleError(error, 'rejectionReasonService.update'));
    }
  },

  remove: async (id) => {
    try {
      return await apiClient.delete(API_ENDPOINTS.REJECTION_REASONS.DELETE(id));
    } catch (error) {
      throw new Error(handleError(error, 'rejectionReasonService.remove'));
    }
  },

  removeMany: async (ids) => {
    try {
      return await apiClient.delete(API_ENDPOINTS.REJECTION_REASONS.DELETE_MULTIPLE, { data: { ids } });
    } catch (error) {
      throw new Error(handleError(error, 'rejectionReasonService.removeMany'));
    }
  },

  toggleStatus: async (id) => {
    try {
      return await apiClient.patch(API_ENDPOINTS.REJECTION_REASONS.TOGGLE_STATUS(id));
    } catch (error) {
      throw new Error(handleError(error, 'rejectionReasonService.toggleStatus'));
    }
  },
};

export default rejectionReasonService;
